/**
 * @generated SignedSource<<620997eac73ff1a5606c15280a248224>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CheckoutChargeAddInput = {
  checkout?: string | null | undefined;
  clientMutationId?: string | null | undefined;
};
export type CheckoutChargeAddMutation$variables = {
  input: CheckoutChargeAddInput;
};
export type CheckoutChargeAddMutation$data = {
  readonly CheckoutChargeAdd: {
    readonly charge: {
      readonly id: string;
      readonly paymentLinkUrl: string | null | undefined;
    } | null | undefined;
    readonly error: string | null | undefined;
    readonly success: string | null | undefined;
  } | null | undefined;
};
export type CheckoutChargeAddMutation = {
  response: CheckoutChargeAddMutation$data;
  variables: CheckoutChargeAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CheckoutChargeAddPayload",
    "kind": "LinkedField",
    "name": "CheckoutChargeAdd",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Charge",
        "kind": "LinkedField",
        "name": "charge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentLinkUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckoutChargeAddMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CheckoutChargeAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6f95e21ddceee0dc88eb419a402de01d",
    "id": null,
    "metadata": {},
    "name": "CheckoutChargeAddMutation",
    "operationKind": "mutation",
    "text": "mutation CheckoutChargeAddMutation(\n  $input: CheckoutChargeAddInput!\n) {\n  CheckoutChargeAdd(input: $input) {\n    charge {\n      id\n      paymentLinkUrl\n    }\n    error\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "0db73e961bd07c3982039941d2be18b6";

export default node;
